export const LOADING_MESSAGES = {
  WALLET_CREATE: 'wallet.create.loading-message'
}

export const ERROR_MESSAGES = {
  INVALID_PASSWORD: 'error-messages.invalid-password',
  MISTYPED_PASSWORD: 'error-messages.mistyped-password',
  INVALID_MNEMONIC: 'error-messages.mnemonic-invalid',
  INVALID_MNEMONIC_QR: 'error-messages.mnemonic-invalid-qr',
}


// WEBPACK FOOTER //
// ./src/constants/messages.js